export const CHECKOUT_URL = 'https://profesor-de-matematica.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/fLNjKHgyNcMMcMQPmk76T7/Imagen_de_ChatGPT_7_oct_2026,_19_12_30.png'

export const PRODUCT_NAME =
  'MEGA PACK PROFESOR DE MATEMÁTICA – 1.º AÑO SECUNDARIA'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: 'layers' as const,
    title: 'MATERIAL DISPERSO',
    desc: 'Guardas ejercicios, actividades, explicaciones y evaluaciones de diferentes fuentes, pero después necesitas ordenarlos y adaptarlos antes de poder utilizarlos.',
  },
  {
    icon: 'clock' as const,
    title: 'PIERDES TIEMPO PREPARANDO',
    desc: 'Cada semana necesitas pensar qué explicar, qué ejercicios entregar, cómo reforzar el tema y qué actividades utilizar para evaluar.',
  },
  {
    icon: 'route' as const,
    title: 'TE FALTA UNA RUTA',
    desc: 'Quieres tener los contenidos de 1.º año organizados desde los fundamentos hasta álgebra, porcentajes, geometría y estadística, siguiendo una secuencia clara.',
  },
  {
    icon: 'refresh' as const,
    title: 'SIGUES ARMANDO TODO DESDE CERO',
    desc: 'Tienes que preparar actividades, problemas, evaluaciones y recursos constantemente cuando podrías partir de una estructura ya organizada.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    icon: 'hash' as const,
    title: 'NÚMEROS NATURALES Y ENTEROS',
    desc: 'Trabaja números naturales, sistema decimal, operaciones, propiedades, operaciones combinadas, potencias, raíces, divisibilidad, MCM, MCD, números enteros, recta numérica y resolución de problemas.',
  },
  {
    icon: 'pie' as const,
    title: 'FRACCIONES, DECIMALES Y NÚMEROS RACIONALES',
    desc: 'Desarrolla fracciones, equivalencias, simplificación, comparación, operaciones, números decimales, conversiones y problemas para aplicar estos contenidos en diferentes situaciones.',
  },
  {
    icon: 'variable' as const,
    title: 'INTRODUCCIÓN AL ÁLGEBRA Y ECUACIONES',
    desc: 'Introduce variables, lenguaje algebraico, expresiones, términos semejantes, propiedad distributiva, valor numérico, ecuaciones y problemas con incógnitas.',
  },
  {
    icon: 'percent' as const,
    title: 'PROPORCIONALIDAD Y PORCENTAJES',
    desc: 'Trabaja razones, proporciones, proporcionalidad directa, regla de tres, porcentajes, descuentos, aumentos y problemas vinculados con situaciones cotidianas.',
  },
  {
    icon: 'triangle' as const,
    title: 'GEOMETRÍA Y MEDICIÓN',
    desc: 'Aborda rectas, ángulos, triángulos, cuadriláteros, polígonos, perímetros, áreas, unidades de medida y problemas geométricos para aplicar los conceptos.',
  },
  {
    icon: 'chart' as const,
    title: 'ESTADÍSTICA, GRÁFICOS Y PROYECTO INTEGRADOR',
    desc: 'Trabaja recolección y organización de datos, tablas, gráficos, frecuencias, media, moda e interpretación de información, finalizando con actividades que integran los contenidos del año.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    icon: 'list' as const,
    title: 'BANCO DE 150 ACTIVIDADES Y EJERCICIOS IMPRIMIBLES',
    desc: '150 actividades organizadas por contenidos para practicar números, fracciones, decimales, álgebra, ecuaciones, porcentajes, geometría y estadística durante todo el año.',
    value: 'Valor: $7.990',
  },
  {
    icon: 'check' as const,
    title: '50 EVALUACIONES + RESPUESTAS',
    desc: 'Una colección de evaluaciones diagnósticas, temáticas, integradoras y recuperatorias para disponer de diferentes propuestas de evaluación acompañadas por respuestas.',
    value: 'Valor: $5.990',
  },
  {
    icon: 'calendar' as const,
    title: 'PLANIFICACIÓN ANUAL + SECUENCIAS DIDÁCTICAS',
    desc: 'Una estructura para organizar objetivos, contenidos y actividades del año junto con secuencias didácticas aplicables a números, fracciones, ecuaciones, porcentajes, geometría y estadística.',
    value: 'Valor: $6.990',
  },
  {
    icon: 'sigma' as const,
    title: 'FICHAS, FÓRMULAS Y RECURSOS VISUALES PARA IMPRIMIR',
    desc: '18 fichas de consulta con operaciones, fracciones, álgebra, ecuaciones, porcentajes, geometría, unidades de medida y estadística para utilizar como apoyo durante las clases.',
    value: 'Valor: $8.990',
  },
  {
    icon: 'puzzle' as const,
    title: 'JUEGOS MATEMÁTICOS, DESAFÍOS Y ACTIVIDADES INTEGRADORAS',
    desc: 'Juegos, desafíos y propuestas para trabajar cálculo, fracciones, ecuaciones, porcentajes, geometría y estadística mediante actividades individuales, en parejas o grupales.',
    value: 'Valor: $9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'clock' as const,
    title: 'MENOS TIEMPO BUSCANDO MATERIAL',
    desc: 'Deja de saltar entre diferentes recursos y trabaja con una ruta que organiza los principales contenidos de Matemática de 1.º año.',
  },
  {
    icon: 'book' as const,
    title: 'MÁS MATERIAL PRÁCTICO',
    desc: 'Dispone de explicaciones, ejercicios, problemas, evaluaciones, fichas y actividades para acompañar diferentes momentos de la enseñanza.',
  },
  {
    icon: 'route' as const,
    title: 'SABES QUÉ TRABAJAR',
    desc: 'Avanza desde números y operaciones hasta fracciones, álgebra, porcentajes, geometría y estadística siguiendo una estructura organizada.',
  },
  {
    icon: 'folder' as const,
    title: 'MÁS ORGANIZACIÓN DOCENTE',
    desc: 'Parte de materiales ya estructurados que puedes seleccionar, adaptar y utilizar según las necesidades de cada curso.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Pasaba bastante tiempo buscando ejercicios para cada tema y después tenía que ordenarlos. Tener números, fracciones, ecuaciones, porcentajes y geometría separados por tomos me ayudó a organizar mejor el material para mis clases.',
    author: 'Mariana López',
    role: 'Profesora de Matemática, 34 años',
    location: 'Buenos Aires, Argentina',
  },
  {
    quote:
      'Lo que más me ayudó fue tener actividades para distintos momentos. Puedo explicar un contenido, elegir ejercicios para practicar y después utilizar las evaluaciones como referencia para revisar lo trabajado.',
    author: 'Carolina Méndez',
    role: 'Docente de secundaria, 39 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Necesitaba una estructura para 1.º año porque tenía muchos archivos guardados y terminaba preparando todo nuevamente. La planificación y las secuencias me permitieron ordenar mejor qué trabajar en cada etapa.',
    author: 'Fernando Ruiz',
    role: 'Profesor de Matemática, 42 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Las fichas me resultaron prácticas para repasar fórmulas y procedimientos. También utilizo varias actividades como apoyo cuando algunos estudiantes necesitan practicar nuevamente un contenido.',
    author: 'Natalia Gómez',
    role: 'Docente, 31 años',
    location: 'Mendoza, Argentina',
  },
  {
    quote:
      'Buscaba material que no fueran solamente ejercicios. Los juegos, actividades integradoras y recursos de planificación me dieron más opciones para trabajar los mismos temas de distintas maneras.',
    author: 'Pablo Martínez',
    role: 'Profesor de secundaria, 45 años',
    location: 'Montevideo, Uruguay',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito preparar material adicional?',
    a: 'El pack incluye contenidos, actividades, ejercicios, evaluaciones y recursos que puedes utilizar como base y adaptar según las necesidades de tu curso.',
  },
  {
    q: '¿Qué contenidos incluye?',
    a: 'Números naturales y enteros, fracciones, decimales, álgebra, ecuaciones, proporcionalidad, porcentajes, geometría, medición, estadística y gráficos.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye actividades, ejercicios, problemas y además un bono con 150 actividades imprimibles.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos con la compra.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizas un único pago, sin mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. El acceso al material es digital.',
  },
  {
    q: '¿Puedo adaptar las actividades?',
    a: 'Sí. Puedes seleccionar y adaptar las propuestas según el nivel y las necesidades de tus estudiantes.',
  },
  {
    q: '¿Puedo utilizarlo durante todo el año?',
    a: 'Sí. Los contenidos están organizados para acompañar los principales temas de Matemática de 1.º año.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes comunicarte mediante el canal de soporte indicado después de realizar tu compra.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Valeria Sosa', city: 'Córdoba', minutes: 2 },
  { name: 'Lucía Fernández', city: 'Rosario', minutes: 5 },
  { name: 'Gabriela Herrera', city: 'Buenos Aires', minutes: 8 },
  { name: 'Andrés Medina', city: 'Mendoza', minutes: 12 },
  { name: 'Romina Castro', city: 'La Plata', minutes: 16 },
  { name: 'Paula Giménez', city: 'Mar del Plata', minutes: 20 },
  { name: 'Sergio Aguirre', city: 'Salta', minutes: 25 },
  { name: 'Florencia Vera', city: 'San Miguel de Tucumán', minutes: 30 },
]
